module.exports = __webpack_public_path__ + "img/bank.ce89a296.svg";